import React from "react";
//http://us2.sourcesoftsolutions.com:3000/myproperties/1
const FanTokenDetails = () => {
  return (
    <div className="col">
      <div className="row align-items-center">
        <div className="col-md-5">
          <div className="company-short-detail">
            <h3>Paris Saint-Germain (PSG)</h3>
            <div className="company-score d-flex align-items-center h-equal">
              <label className="d-flex align-items-center">
                <img src="/img/tags.png" alt="" />
                <span className="ml-2">$14.32</span>
              </label>
              <label className="d-flex align-items-center">
                <svg
                  width="26"
                  height="19"
                  viewBox="0 0 26 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.69253 17.0263H2.14914C1.84681 17.0263 1.66441 16.8598 1.58261 16.7605C1.4414 16.589 1.38669 16.3659 1.43261 16.1483C2.16805 12.6619 5.28556 10.1158 8.8845 10.0332C8.94445 10.0354 9.00454 10.0369 9.06499 10.0369C9.12596 10.0369 9.18659 10.0354 9.24707 10.0331C10.1271 10.0529 11.6994 10.5772 12.5177 10.8804C12.8838 11.0162 13.2921 10.8332 13.4296 10.4718C13.5671 10.1104 13.3817 9.70743 13.0156 9.57173C12.8983 9.52826 12.0676 9.12666 11.9489 9.08808C13.121 8.22034 13.8808 6.83811 13.8808 5.28404C13.8808 2.66335 11.7204 0.531219 9.06499 0.531219C6.40955 0.531219 4.24921 2.66335 4.24921 5.28404C4.24921 6.83951 5.01024 8.22282 6.18412 9.09042C5.10868 9.43983 4.09949 9.98318 3.21629 10.7002C1.59692 12.0148 0.470981 13.8484 0.0459533 15.8634C-0.0872597 16.4947 0.0722984 17.1432 0.483729 17.6425C0.89307 18.1393 1.50011 18.4242 2.14914 18.4242H9.69253C10.0837 18.4242 10.4007 18.1113 10.4007 17.7253C10.4007 17.3392 10.0837 17.0263 9.69253 17.0263ZM5.66561 5.28404C5.66561 3.43411 7.19055 1.92911 9.06499 1.92911C10.9394 1.92911 12.4644 3.43411 12.4644 5.28404C12.4644 7.07917 11.0283 8.54944 9.23049 8.63496C9.17536 8.63398 9.12023 8.63314 9.06499 8.63314C9.00961 8.63314 8.95426 8.63394 8.89895 8.63492C7.10135 8.54916 5.66561 7.079 5.66561 5.28404Z"
                    fill="black"
                  ></path>
                  <g clip-path="url(#clip0_101_247)">
                    <path
                      d="M19.0673 17.2074H13.1522C12.9151 17.2074 12.7721 17.0768 12.7079 16.999C12.5972 16.8645 12.5543 16.6896 12.5903 16.5189C13.167 13.785 15.6116 11.7885 18.4337 11.7237C18.4807 11.7255 18.5278 11.7266 18.5752 11.7266C18.623 11.7266 18.6706 11.7254 18.718 11.7237C19.4081 11.7392 20.641 12.1503 21.2826 12.3881C21.5698 12.4945 21.8899 12.351 21.9978 12.0676C22.1056 11.7843 21.9602 11.4683 21.6731 11.3619C21.5811 11.3278 20.9297 11.0129 20.8367 10.9826C21.7558 10.3022 22.3515 9.21831 22.3515 7.99969C22.3515 5.94468 20.6575 4.27277 18.5752 4.27277C16.493 4.27277 14.7989 5.94468 14.7989 7.99969C14.7989 9.21941 15.3957 10.3041 16.3162 10.9845C15.4729 11.2584 14.6815 11.6845 13.989 12.2467C12.7191 13.2776 11.8362 14.7154 11.503 16.2955C11.3985 16.7905 11.5236 17.2991 11.8462 17.6905C12.1672 18.0801 12.6432 18.3035 13.1522 18.3035H19.0673C19.374 18.3035 19.6227 18.0582 19.6227 17.7555C19.6227 17.4528 19.374 17.2074 19.0673 17.2074ZM15.9096 7.99969C15.9096 6.54907 17.1054 5.36892 18.5752 5.36892C20.0451 5.36892 21.2409 6.54907 21.2409 7.99969C21.2409 9.40735 20.1148 10.5603 18.705 10.6273C18.6618 10.6265 18.6186 10.6259 18.5752 10.6259C18.5318 10.6259 18.4884 10.6265 18.445 10.6273C17.0354 10.56 15.9096 9.40721 15.9096 7.99969Z"
                      fill="black"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_101_247">
                      <rect
                        width="14.2166"
                        height="14.0308"
                        fill="white"
                        transform="translate(11.5029 4.27277)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
                <span className="ml-2">19,696</span>
              </label>
            </div>
            <ul className="list-unstyled row row-form">
              <li className="col-sm-6">
                <label className="label-tag">Circulating Supply</label>
                <span className="label-rate">3,111,091</span>
              </li>
              <li className="col-sm-6">
                <label className="label-tag">Total Supply</label>
                <span className="label-rate">20,000,000</span>
              </li>
              <li className="col-sm-6">
                <label className="label-tag">24h High/Low</label>
                <span className="label-rate">$14.54 / $13.95</span>
              </li>
              <li className="col-sm-6">
                <label className="label-tag">Total Volume 24h</label>
                <span className="label-rate brand-Primary">
                  $7,994,222 (561,916 PSG)
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-7">
          <div className="row row-form">
            <div className="col-md-6">
              <div className="volume-box h-100">
                <ul className="list-unstyled">
                  <li>
                    <label className="label-tag">Market Cap</label>
                    <div className="label-rate">$44,550,080.00</div>
                  </li>
                  <li>
                    <label className="label-tag">Market Cap</label>
                    <div className="label-rate">
                      $345,488.00{" "}
                      <span className="dc-value">
                        0.7867%{" "}
                        <svg
                          width="20"
                          height="13"
                          viewBox="0 0 20 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 0.865234L16.29 3.13704L11.41 7.97825L7.41 4.01004L0 11.3711L1.41 12.7699L7.41 6.81755L11.41 10.7858L17.71 4.54575L20 6.81755V0.865234H14Z"
                            fill="#15BE77"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="volume-box h-100">
                <ul className="list-unstyled">
                  <li>
                    <label className="label-tag">All time high price</label>
                    <div className="label-rate">
                      $61.23{" "}
                      <span className="inc-value">
                        76.77%
                        <svg
                          width="20"
                          height="13"
                          viewBox="0 0 20 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 12.2636L16.29 9.99183L11.41 5.15059L7.41 9.11882L0 1.75775L1.41 0.358948L7.41 6.31129L11.41 2.34306L17.71 8.58311L20 6.31129V12.2636H14Z"
                            fill="#FF4B4B"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </li>
                  <li>
                    <label className="label-tag">All time high price</label>
                    <div className="label-rate">
                      $2.77{" "}
                      <span className="dc-value">
                        0.7867%{" "}
                        <svg
                          width="20"
                          height="13"
                          viewBox="0 0 20 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 0.865234L16.29 3.13704L11.41 7.97825L7.41 4.01004L0 11.3711L1.41 12.7699L7.41 6.81755L11.41 10.7858L17.71 4.54575L20 6.81755V0.865234H14Z"
                            fill="#15BE77"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FanTokenDetails;
